export const visit = (vm, at) => {
at({ "de": { "pricing-pages-ui": { "phone-supportV2": { "needHelp": "Ben\xF6tigen Sie Hilfe bei der Auswahl eines Abonnements?", "stillHaveQuestions": "Haben Sie noch Fragen dazu, wie die Software von HubSpot Ihrem Unternehmen helfen kann?" } } } });
};